import {combineReducers} from 'redux'
import {constants as kandyConstants} from 'kandy-redux'
import {reducer as formReducer} from 'redux-form'

import company from './reducers/company'
import appReducer from './reducers'
import lossAssessmentReducer from './lossAss/reducers'
import callBy5gReducer from './reducers/call';
import reportDetailReducer from './reducers/reportDetail'
import uploadReducer from './reducers/uploadReducer';

/**
 * Reducer index.
 * Combines reducers into a single reducer.
 */
const reducer = combineReducers({
	app: appReducer,
	company,
	lossAss: lossAssessmentReducer,
	form: formReducer,
	callBy5g: callBy5gReducer,
	reportDetail: reportDetailReducer,
	uploadReducer
	// router: routerStateReducer,
})

const rootReducer = (state, action) => {
	if (action.type === kandyConstants.LOGOUT) {
		state.app = undefined,
		state.lossAss = undefined
	}

	return reducer(state, action)
}

export default rootReducer
